module.exports = __webpack_public_path__ + "static/img/2_1_2_4.1254e80c.jpg";